/**
* @license Copyright (c) Microsoft Corporation.  All rights reserved.
*/
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from "react";
var CommonUtils = /** @class */ (function () {
    function CommonUtils() {
    }
    CommonUtils.getTopWindow = function () {
        try {
            // Testing top window's availability
            // In iframe this will cause an exception as you can't access dispatchEvent
            window.top.dispatchEvent;
            return window.top;
        }
        catch (e) {
            // Assuming iframe scenario
            // Getting top available window
            return this.getTopIframeWindow();
        }
    };
    CommonUtils.getTopIframeWindow = function () {
        var current = window;
        var parent = current.parent;
        var retry = 10; // Additional safety
        try {
            while (retry && parent && current !== parent) {
                // Testing window's availability
                if (!(parent === null || parent === void 0 ? void 0 : parent.dispatchEvent)) {
                    break;
                }
                current = parent;
                parent = current.parent;
                --retry;
            }
        }
        catch (e) {
            // Silencing
        }
        return current;
    };
    CommonUtils.getFlyoutRoot = function (utils, fluentDesignLanguage) {
        var _a;
        try {
            if (!((_a = fluentDesignLanguage === null || fluentDesignLanguage === void 0 ? void 0 : fluentDesignLanguage.mountNodeSelector) === null || _a === void 0 ? void 0 : _a.length) || !utils.isFeatureEnabled("GlobalFluentProvider")) {
                return null;
            }
            return document.querySelector(fluentDesignLanguage.mountNodeSelector) || document.documentElement.closest(fluentDesignLanguage.mountNodeSelector) || null;
        }
        catch (e) {
            return null;
        }
    };
    CommonUtils.useFlyoutRoot = function (utils, fluentDesignLanguage) {
        var _a = __read(useState(CommonUtils.getFlyoutRoot(utils, fluentDesignLanguage)), 1), root = _a[0];
        return root;
    };
    return CommonUtils;
}());
export { CommonUtils };
